import { AxiosRequestConfig } from 'axios';

/** 再送しても副作用が重ならない（読むだけの）メソッド。 */
const SAFE_METHODS = new Set(['get', 'head', 'options']);

/**
 * ADM-02-AC2。サーバーが要求を処理する前（認証段階）に返す401のcode。
 *
 * DRF + simplejwt 5.3.1 の JWTAuthentication と権限確認は view の処理より前に
 * 動き、拒否した場合は次のcodeで401を返す（api/exceptions.py が code を付ける）。
 * このcodeの401なら更新系の要求も処理されていないので、refresh後に再送してよい。
 */
const PRE_PROCESSING_401_CODES = new Set([
  'token_not_valid',
  'not_authenticated',
  'bad_authorization_header',
  'user_not_found',
  'user_inactive',
  'password_changed',
]);

/**
 * 401の後に元の要求を再送してよいか。
 *
 * 取得系は何度送っても結果が変わらないので常に再送する。更新系（POST/PUT/
 * PATCH/DELETE）は、サーバーが処理していないと確かな401のときだけ再送する。
 * それ以外の401は処理済みの可能性があり、再送すると二重に実行されうる。
 */
export function canReplayAfter401(config: AxiosRequestConfig, data: unknown): boolean {
  const method = (config.method ?? 'get').toLowerCase();
  if (SAFE_METHODS.has(method)) return true;
  const code =
    data && typeof data === 'object' ? (data as { code?: unknown }).code : undefined;
  return typeof code === 'string' && PRE_PROCESSING_401_CODES.has(code);
}
